module.exports = __webpack_public_path__ + "24fd8f16af47ca58118598058174902c.svg";